var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArt = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconArt",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 28.2",
  style: {
    enableBackground: "new 0 0 45.9 28.2"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0a{fill:none;stroke:#6FC9D1;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1a{fill:#6FC9D1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0a",
  d: "M42.3,1H23l0,0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23l0,0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1a",
  d: "M7.4,17.2c0-2.1,2.1-3.1,7.1-3.5c0-1.5-0.6-2.9-2.8-2.9c-1.4,0-2.7,0.7-3.5,1.3l-0.4-0.6 c0.7-0.5,2.3-1.4,4-1.4c2.5,0,3.5,1.6,3.5,3.6v5.9h-0.7l-0.1-1.4h0c-1.1,0.9-2.5,1.6-3.9,1.6C8.9,19.7,7.4,18.9,7.4,17.2z  M14.5,17.3v-3c-4.7,0.4-6.2,1.3-6.2,2.8c0,1.3,1.2,1.8,2.5,1.8C11.9,18.9,13.2,18.4,14.5,17.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1a",
  d: "M20.3,10.2H21l0.1,2.3h0c1-1.5,2.5-2.5,4.4-2.5c0.6,0,1.3,0.1,1.9,0.4l-0.2,0.8c-0.7-0.2-1-0.3-1.7-0.3 c-1.5,0-2.9,0.8-4.2,2.9v5.8h-0.9V10.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1a",
  d: "M33.1,16v-5.1h-2.8v-0.7l2.8-0.1l0.1-3.1h0.7v3.1h4.9v0.7h-4.9v5.1c0,1.8,0.5,2.9,2.6,2.9 c1,0,1.7-0.2,2.5-0.5l0.2,0.7c-0.8,0.3-1.7,0.6-2.8,0.6C33.8,19.7,33.1,18.2,33.1,16z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconArt.a978bfa7.svg";
export { ForwardRef as ReactComponent };